import get from 'lodash/get'
import isArray from 'lodash/isArray'
import { isUserAmTeam, isUserBeta } from './user';
import appData from './appData'

export const allowed = (user, category, permission, resource) => {
	if ('roles' === category) {
		// If the user does not have a role, return false.
		if (!(user.role in roles)) {
			return false
		}

		// If we don't have a resource, do a quick check for the exact permission.
		if (!resource) {
			return roles[user.role].includes(permission)
		}

		// If the exact permission exists, then return true.
		if (roles[user.role].includes(permission)) {
			return true
		}

		// Check if the user has a conditional permission.
		const permissions = roles[user.role].filter(p => p.startsWith(permission))
		const passed      = []
		if (permissions.length) {
			permissions.forEach(p => {
				const attribute = p.replace(permission + '.', '')
				passed.push(resource[attribute])
			})

			return passed.every(p => p)
		}

		return false
	}

	if ('amteam' === category) {
		return get(user, 'isAmTeam')
	}

	if ('beta' === category) {
		return get(user, 'inBeta') || get(user, 'beta.enabled')
	}

	let property = get(user, category, []);

	if ('features' === category && ( !property || ! isArray(property) )) {
		// Try to find features in the app data.
		property = appData.get('features', [])
	}

	return property.includes(permission)
}

/**
 * Determines if the passed user is in the AM Team group.
 *
 * @param {Object} user The user object.
 *
 * @returns {boolean} True if user in AM Team group.
 */
export const allowedInAmTeam = user => {
	return isUserAmTeam(user);
};

/**
 * Determines if the passed user is in the AM Team group and/or the beta group.
 *
 * @param {Object} user The user object.
 *
 * @returns {boolean} True if user in AM Team group and/or the beta group.
 */
export const allowedInBeta = user => {
	return isUserBeta(user) || isUserAmTeam(user);
};

const roles = {
	owner : [
		'analytics.view',
		'publish.status',
		'publish.embed',
		'site.edit',
		'site.connect',
		'site.create',
		'folder.edit',
		'folder.connect',
		'folder.create',
		'folder.delete',
		'campaign.edit',
		'campaign.create',
		'campaign.delete',
		'campaign.archive',
		'bulk.select'
	],
	admin : [
		'analytics.view',
		'publish.status',
		'publish.embed',
		'site.edit',
		'site.connect',
		'site.create',
		'folder.edit',
		'folder.connect',
		'folder.create',
		'folder.delete',
		'campaign.edit',
		'campaign.create',
		'campaign.delete',
		'campaign.archive',
		'bulk.select'
	],
	manager : [
		'analytics.view',
		'publish.status',
		'publish.embed',
		'site.connect',
		'folder.connect',
		'folder.create',
		'folder.edit',
		'campaign.edit',
		'campaign.create',
		'campaign.delete',
		'campaign.archive',
		'bulk.select'
	],
	author : [
		'publish.embed',
		'analytics.view',
		'campaign.edit.can_edit',
		'bulk.select'
	],
	viewer : []
}
